import { DefaultError, useMutation } from "@tanstack/react-query";
import { deleteSettingModule } from "../api/deleteSettingModule";
import { invalidateModuleListByBrandSettingQuery } from "../queries/useModuleListByBrandSettingQuery";

type Params = {
  brandId: string;
  settingId: string;
  moduleId: string;
  onSuccess: () => void;
};

export const useDeleteSettingModuleMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await deleteSettingModule({
        brandId: params.brandId,
        settingId: params.settingId,
        moduleId: params.moduleId,
      });
    },
    onSuccess: (_, params) => {
      invalidateModuleListByBrandSettingQuery(params.brandId, params.settingId);
      params.onSuccess();
    },
  });
};
